/* Cart Drawer Plus Ultra:
   - Gates the checkout button on the terms & conditions checkbox (if that
     block is present), on top of the existing "disabled while cart is
     empty" behavior.
   - Uses event delegation + a MutationObserver instead of binding directly
     to the checkbox/button, since cart.js replaces that markup wholesale
     with fresh server-rendered HTML on every AJAX cart update.
   - Resets the terms checkbox when the shopper returns from checkout via
     browser back / bfcache so acceptance is required again. */
(function () {
  function getTermsCheckbox() {
    return document.querySelector('[data-hdt-cdpu-terms-checkbox]');
  }

  function syncCheckoutState() {
    const checkbox = getTermsCheckbox();

    document.querySelectorAll('[data-hdt-cdpu-checkout-button]').forEach((button) => {
      const cartEmpty = button.getAttribute('data-hdt-cdpu-cart-empty') === 'true';
      button.disabled = cartEmpty || (checkbox ? !checkbox.checked : false);
    });
  }

  function resetTermsCheckbox() {
    const checkbox = getTermsCheckbox();
    if (!checkbox) return;
    if (checkbox.checked) checkbox.checked = false;
    syncCheckoutState();
  }

  function isBackForwardNavigation(event) {
    if (event && event.persisted) return true;
    const nav = window.performance && performance.getEntriesByType
      ? performance.getEntriesByType('navigation')[0]
      : null;
    if (nav && nav.type === 'back_forward') return true;
    if (window.performance && performance.navigation && performance.navigation.type === 2) {
      return true;
    }
    return false;
  }

  document.addEventListener('change', (event) => {
    if (event.target.matches && event.target.matches('[data-hdt-cdpu-terms-checkbox]')) {
      syncCheckoutState();
    }
  });

  document.addEventListener('DOMContentLoaded', syncCheckoutState);
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    syncCheckoutState();
  }

  /* Checkout → browser Back restores this page from bfcache with the
     checkbox still checked. Clear it so terms must be accepted again. */
  window.addEventListener('pageshow', (event) => {
    if (isBackForwardNavigation(event)) {
      resetTermsCheckbox();
    } else {
      syncCheckoutState();
    }
  });

  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && 'MutationObserver' in window) {
    const observer = new MutationObserver(() => syncCheckoutState());
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }
})();
